import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { makeStyles } from '@material-ui/styles';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Paper,
  InputAdornment,
  FormControlLabel,
  emphasize
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import UpdateIcon from '@material-ui/icons/Update';
import Alert from '@material-ui/lab/Alert';
import Controls from '../controls/Controls';
import { baseUrl, employerTypes, monthlySalaryReceiveDateTypes } from '../../utils/constants';
import { useEmployerContext } from '../../context/employer_context';
import { useConstantsContext } from '../../context/constants_context';
import CircularIndeterminate from '../CircularIndeterminate';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function EmployerSetup(empStage) {
  const classes = useStyles();
  const { employerRefId, currentEmployer, setCurrentEmployer, setEmployerRefId } =
    useEmployerContext();
  const { paypoints } = useConstantsContext();
  const [expanded, setExpanded] = React.useState(false);
  const [hideTrustLevel, setHideTrustLevel] = useState(false);
  const [hideSalaryType, setHideSalaryType] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (empStage === 'new') {
      console.log('enter here as new');
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (employerRefId > 0) {
      console.log('enter here as existing', employerRefId);
      if (currentEmployer.enableEntryTrust === true) {
        setHideTrustLevel((oldState) => !oldState);
      }
      if (currentEmployer.monthlySalaryEnabled === true) {
        setHideSalaryType((oldState) => !oldState);
      }
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employerRefId]);

  const PersonalDetailsSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, 'Employer Name is too Short!')
      .max(50, 'Employer Name is too Long!')
      .required('Employer name required'),
    paypointRefId: Yup.number().required('Paypoint is required'),
    employerType: Yup.number().required('Employer Type is required')
  });

  const formik = useFormik({
    initialValues: currentEmployer,
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      values.providerLegalDescription = values.name;
      if (values.monthlySalaryEnabled === true) {
        values.salaryDateDay = values.monthlySalaryDateDay;
        values.salaryDateType = values.monthlySalaryDateType;
      }
      console.log('employer details 2', values);
      console.log('employer RefId', employerRefId);
      if (values.employerRefId > 0) {
        updateEmployer(values);
        console.log('to employerRefId', values);
      } else {
        console.log('to update', values);
        addEmployer(values);
      }
    }
  });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const updateEmployer = (emp) => {
    console.log('employer Ref', employerRefId);
    emphasize.refId = employerRefId;
    const jsonClient = [];
    jsonClient.push(emp);
    console.log('employer update now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/setting/saveemployer?employerRefId=${employerRefId}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((result) => result.json())
      .then(
        (result) => {
          setEmployerRefId(result.replyMessage);
          <Alert variant="filled" severity="success">
            Employer Saved Successfully!
          </Alert>;
        },
        (error) => {
          <Alert variant="filled" severity="error">
            Error in Saving Employer!, {error}
          </Alert>;
        }
      );
  };

  const addEmployer = (prod) => {
    const jsonClient = [];
    jsonClient.push(prod);
    console.log('employer stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/setting/addemployer`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((result) => result.json())
      .then(
        (result) => {
          console.log('employer add result', result);
          setEmployerRefId(result.replyMessage);
          <Alert variant="filled" severity="success">
            Employer Saved Successfully!
          </Alert>;
        },
        (error) => {
          <Alert variant="filled" severity="error">
            Error in Saving Employer!, {error}
          </Alert>;
        }
      );
  };

  if (loading) return <CircularIndeterminate />;

  return (
    <Card>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate>
            <Typography variant="subtitle1" gutterBottom>
              Employer Setup...
            </Typography>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              <Grid item xs={6} sm={5}>
                <Controls.Input name="name" label="Employer Name" />
              </Grid>
              <Grid item xs={6} sm={5}>
                <Controls.Input name="registrationNumber" label="Registration Number" />
              </Grid>
              <Grid item xs={6} sm={5}>
                <Controls.SelectJson
                  name="employerType"
                  label="Employer Type"
                  options={employerTypes}
                />
              </Grid>
              <Grid item xs={6} sm={5}>
                <Controls.Input name="mainContactPerson" label="Contact Person" />
              </Grid>
              <Grid item xs={6} sm={5}>
                <Controls.Input name="mainContactMail" label="Email" />
              </Grid>
              <Grid item xs={6} sm={5}>
                <Controls.Input name="mainContactNumber" label="Contact Number" />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Controls.CheckBox
                  name="forceEmployerApproval"
                  label="Force Employer Approval"
                  // checked="currentEmployer.forceEmployerApproval"
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Controls.CheckBox
                  name="forceDeductionOverrides"
                  label="Force Deduction Overrides"
                  // checked="currentEmployer.forceDeductionOverrides"
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Controls.CheckBox
                  name="isStaff"
                  label="Is Staff"
                  // checked="currentEmployer.isStaff"
                  paddingLeft={4}
                />
              </Grid>
              <Grid item xs={6} sm={5} justifyContent="left">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={currentEmployer.enableEntryTrust}
                      name="enableEntryTrust"
                      onChange={(e) => {
                        setHideTrustLevel((oldState) => !oldState);
                      }}
                    />
                  }
                  label="Enable Entry Trust"
                />
              </Grid>
              {hideTrustLevel && (
                <Grid item xs={6} sm={5} justifyContent="left">
                  <Controls.Input name="trustLevel" label="Trust Level" type="number" />
                </Grid>
              )}
              <Grid item xs={6} sm={10} justifyContent="left" paddingBottom={4}>
                <Controls.InputNumber name="settlementValidDays" label="Settlement Valid Days" />
              </Grid>
            </Grid>
            <div className={classes.root}>
              <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Salary Rules</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <Paper elevation={3}>
                        <Grid item xs={6} sm={5} paddingTop={4} paddingLeft={2}>
                          <Controls.SelectJson
                            name="paypointRefId"
                            label="Paypoint"
                            options={paypoints}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} paddingTop={1} paddingLeft={2}>
                          <Controls.CheckBox
                            name="forceDeductionOverrides"
                            label="Trusted Employer"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} paddingTop={1} paddingLeft={2}>
                          <Controls.CheckBox
                            name="payrollPaypointlDeductionsEnabled"
                            label="Enable Payroll Deductions"
                          />
                        </Grid>
                        <Grid item xs={6} sm={5} paddingTop={1} paddingBottom={1} paddingLeft={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={currentEmployer.monthlySalaryEnabled}
                                name="monthlySalaryEnabled"
                                onChange={(e) => {
                                  console.log(e.target.checked);
                                  setHideSalaryType((oldState) => !oldState);
                                }}
                              />
                            }
                            label="Monthly Salary Enabled"
                          />
                        </Grid>

                        {hideSalaryType && (
                          <Grid item xs={6} sm={5} paddingTop={1} paddingLeft={6}>
                            <Controls.SelectJson
                              name="monthlySalaryDateType"
                              label="Monthly Workers Salary Rule"
                              options={monthlySalaryReceiveDateTypes}
                            />
                          </Grid>
                        )}
                        {hideSalaryType && (
                          <Grid
                            item
                            xs={12}
                            sm={5}
                            paddingTop={1}
                            paddingLeft={6}
                            paddingBottom={4}
                          >
                            <Controls.Input
                              name="monthlySalaryDateDay"
                              label="Monthly Salary Date Type"
                              type="number"
                            />
                          </Grid>
                        )}
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Product Rules</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={2}
                    marginTop={2}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12} justifyContent="center" alignItems="center">
                      <Paper elevation={3}>
                        <Grid item xs={12} sm={4} paddingTop={1} paddingLeft={2}>
                          <Controls.CheckBox
                            name="enforceSingleProduct"
                            label="Allow only one active loan instance at a time"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} paddingTop={1} paddingLeft={2}>
                          <Controls.CheckBox
                            name="affordabilityOverride"
                            label="Enable Affordability Overrides"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} paddingTop={2} paddingLeft={2}>
                          <Controls.InputNumber
                            name="affordabilityReoccuringIncomePercent"
                            label="Re-occurring income exposure:"
                            variant="outlined"
                            helperText="% per Annum"
                            InputProps={{
                              endAdornment: <InputAdornment position="end">%</InputAdornment>
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} paddingTop={1} paddingLeft={2}>
                          <Controls.InputNumber
                            name="affordabilityAdHocIncomePercent"
                            label="Ad-Hoc income exposure:"
                            helperText="% per Annum"
                            InputProps={{
                              endAdornment: <InputAdornment position="end">%</InputAdornment>
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} paddingTop={1} paddingLeft={2} paddingBottom={2}>
                          <Controls.InputNumber
                            name="affordabilityVariableIncomePercent"
                            label="Variable income exposure:"
                            helperText="% per Annum"
                            InputProps={{
                              endAdornment: <InputAdornment position="end">%</InputAdornment>
                            }}
                          />
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
            <Grid
              item
              xs={12}
              sm={12}
              margin={2}
              container
              direction="row"
              justifyContent="right"
              alignItems="right"
            >
              <Grid item xs={12} sm={1} marginRight={2}>
                <Controls.Button type="submit" variant="contained" startIcon={<SaveIcon />}>
                  Save...
                </Controls.Button>
              </Grid>
              {/* <Grid item xs={12} sm={1}>
                <Button type="submit" variant="outlined" startIcon={<UpdateIcon />}>
                  Update
                </Button>
              </Grid> */}
              {/* <Grid item xs={12} sm={1}>
                <Button
                  type="button"
                  variant="outlined"
                  startIcon={<UpdateIcon />}
                  // onClick={() => handleNewClient()}
                >
                  Deactivate
                </Button>
              </Grid> */}
              <Grid item xs={12} sm={1} marginLeft={2} marginRight={2}>
                <Button
                  type="button"
                  variant="outlined"
                  startIcon={<UpdateIcon />}
                  // onClick={() => handleNewClient()}
                >
                  Activate
                </Button>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </CardContent>
    </Card>
  );
}
